// Axios
import { _axios } from "../../Base_Axios_Config/_axios";
// Axios

// Models
import { I_EditFormSampleSendingData } from "../../../Models/sendingDataSchema";
import { AxiosResponse } from "axios";
import { I_Message } from "../../../Models/interfaces";
// Models

export const editSingleFormSampleService = async (_data: {
  userToken: string;

  _data: {
    formSampleId: string;
    _data: I_EditFormSampleSendingData;
  };
}): Promise<
  AxiosResponse<{
    error: number;
    messages: I_Message[];
    result: {};
  }>
> => {
  return _axios.post(
    `/form-samples/${_data._data.formSampleId}/edit`,
    _data._data._data,
    {
      headers: {
        Authorization: `Bearer ${_data.userToken}`,
      },
    }
  );
};
